import { os } from '@repo/common-utils';
import { useWorkingPlatform } from '@repo/platform';
import { useRouter } from 'next/navigation';

export const useExitService = () => {
  const router = useRouter();
  const { workingPlatform, browserType } = useWorkingPlatform();
  const exitService = () => {
    if (workingPlatform === 'kbank') {
      if (os.name === 'iOS') {
        window?.webkit?.messageHandlers?.closeKbankWebView?.postMessage('');
      } else if (os.name === 'Android') {
        window?.kbw?.closeKbankWebView();
      } else {
        router.replace('/');
      }
    } else if (browserType !== 'system' && (!window.opener || window.opener === window)) {
      router.replace('/');
    } else {
      window.close();
    }
  };

  return { exitService };
};
